import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-listing-container',
    templateUrl: './listing-container.component.html',
    styleUrls: ['./listing-container.component.scss'],
})
export class ListingContainerComponent implements OnInit {
    @Input() filters: { [p: string]: string | string[] } = {};

    constructor(private activatedRoute: ActivatedRoute) {
        this.activatedRoute.queryParams.subscribe(params => {
            // console.log(params, 'params');
            this.filters = params;
        });
    }

    ngOnInit() {}
}
